import {Outlet} from 'react-router-dom';
import Header from './components/Header';
import styles from './ProtocolLayout.module.less';

const ProtocolLayout: React.FC = () => (
    <div className={styles.layout}>
        <Header />
        <main className={styles.content}>
            <Outlet />
        </main>
    </div>
);

export default ProtocolLayout;
